import React, { useState } from 'react';
import { Auth } from 'aws-amplify';

const CustomLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const user = await Auth.signIn(username, password);
      console.log('User successfully signed in:', user);
      // Redirect to the app or handle login success
    } catch (err) {
      setError(err.message || 'Error logging in');
      console.error('Error signing in', err);
    }
  };

  return (
    <div>
      AAAAA
    </div>
  );
};

export default CustomLogin;